<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'VoteSetting'
};
</script>

<style>
</style>
